import dalImg from "../assets/images/dal.jpg";
import gulmargImg from "../assets/images/gulmarg.jpg";
import gondolaImg from "../assets/images/gondola.jpg";
import sonmargImg from "../assets/images/sonmarg.jpg";
import pahalgamImg from "../assets/images/pahalgam.jpg";

interface ImageProps {
  src: string;
  alt: string;
}

interface ICard {
  title: string;
  description: string;
  image: ImageProps;
  distanceFromSrinagar: string;
  famousFor: string;
  activities: string[];
  bestTimeToVisit: string;
  slug: string;
}

export const DestinationsData: ICard[] = [
  {
    title: "Kashmir",
    description:
      "Kashmir Valley, often referred to as 'Paradise on Earth,' is renowned for its breathtaking landscapes, snow-capped mountains, serene lakes, and vibrant culture. It’s a must-visit destination for nature lovers and those seeking tranquility.",
    image: {
      src: dalImg, // Placeholder image
      alt: "Kashmir Valley",
    },
    distanceFromSrinagar: "0 km",
    famousFor: "Lush green meadows, lakes, snow-capped peaks",
    activities: ["Shikara rides", "Trekking", "Photography", "Cultural tours"],
    bestTimeToVisit: "April to October",
    slug: "Kashmir",
  },
  {
    title: "Ladakh",
    description:
      "Embark on a breathtaking journey aboard the Gulmarg Gondola, one of the most spectacular cable car rides in the world. Ascend to a staggering height of over 13,000 feet, where you'll be greeted by panoramic views of snow-capped peaks, dense forests, and the serene beauty of the Himalayas.",
    image: {
      src: gondolaImg,
      alt: "Gondola Ride in Gulmarg",
    },
    distanceFromSrinagar: "50 km",
    famousFor: "Cable car ride, panoramic views",
    activities: ["Cable car ride", "Photography", "Trekking"],
    bestTimeToVisit:
      "December to March (for snow activities), April to June (for sightseeing)",
    slug: "Ladakh",
  },

  {
    title: "Srinagar",
    description:
      "The summer capital of Jammu and Kashmir, Srinagar is known for its beautiful gardens, historic sites, and the iconic Dal and Nigeen Lakes.",
    image: {
      src: dalImg, // Placeholder image
      alt: "Srinagar",
    },
    distanceFromSrinagar: "0 km",
    famousFor: "Mughal gardens, Dal Lake, traditional Kashmiri culture",
    activities: ["Shikara rides", "Heritage tours", "Shopping"],
    bestTimeToVisit: "April to October",
    slug: "Srinagar",
  },
  {
    title: "Gulmarg",
    description:
      "Gulmarg, often referred to as the 'Meadow of Flowers,' is a popular hill station and skiing destination. Known for its lush green meadows and snow-covered peaks, it offers stunning views and thrilling adventures all year round.",
    image: {
      src: gulmargImg,
      alt: "Gulmarg",
    },
    distanceFromSrinagar: "50 km",
    famousFor: "Skiing, lush meadows, and vibrant flowers",
    activities: ["Skiing", "Snowboarding", "Trekking", "Golfing"],
    bestTimeToVisit:
      "December to March (for snow activities), April to June (for sightseeing)",
    slug: "Gulmarg",
  },

  {
    title: "Sonmarg",
    description:
      "Sonmarg, meaning 'Meadow of Gold,' is a beautiful town surrounded by snow-capped mountains and lush green meadows. It's a gateway to the famous Thajiwas Glacier and serves as the base for several treks.",
    image: {
      src: sonmargImg,
      alt: "Sonmarg",
    },
    distanceFromSrinagar: "80 km",
    famousFor: "Golden meadows, Thajiwas Glacier",
    activities: ["Trekking", "Camping", "Fishing", "Horse riding"],
    bestTimeToVisit: "May to October",
    slug: "Sonmarg",
  },
  {
    title: "Pahalgam",
    description:
      "Pahalgam, known for its picturesque landscapes, is a charming town nestled in the Lidder Valley. It's a popular base for trekking, fishing, and exploring the nearby Betaab Valley and Aru Valley.",
    image: {
      src: pahalgamImg,
      alt: "Pahalgam",
    },
    distanceFromSrinagar: "95 km",
    famousFor: "Scenic beauty, trekking base",
    activities: ["Trekking", "Fishing", "Golfing", "Horse riding"],
    bestTimeToVisit: "April to November",
    slug: "Pahalgam",
  },

  {
    title: "Doodhpathri",
    description:
      "Doodhpathri, or 'Valley of Milk,' is a hidden gem known for its pristine meadows and cool breeze, offering a serene escape from the hustle and bustle.",
    image: {
      src: dalImg, // Placeholder image
      alt: "Doodhpathri",
    },
    distanceFromSrinagar: "42 km",
    famousFor: "Lush green meadows, tranquil atmosphere",
    activities: ["Trekking", "Picnicking", "Nature walks"],
    bestTimeToVisit: "May to September",
    slug: "Doodhpathri",
  },
  {
    title: "Gurez Valley",
    description:
      "Gurez Valley is a remote and picturesque valley in northern Kashmir, surrounded by majestic mountains and the pristine Kishanganga River. It's an unspoiled paradise for nature lovers.",
    image: {
      src: dalImg, // Placeholder image
      alt: "Gurez Valley",
    },
    distanceFromSrinagar: "123 km",
    famousFor: "Untouched beauty, Kishanganga River, Habba Khatoon peak",
    activities: ["Trekking", "Camping", "Fishing"],
    bestTimeToVisit: "May to September",
    slug: "Gurez",
  },
  {
    title: "Yusmarg",
    description:
      "Yusmarg, or 'Meadow of Jesus,' is a tranquil and serene destination surrounded by dense forests and beautiful pastures. It’s ideal for those seeking solitude and peace.",
    image: {
      src: dalImg, // Placeholder image
      alt: "Yusmarg",
    },
    distanceFromSrinagar: "47 km",
    famousFor: "Lush green meadows, dense pine forests",
    activities: ["Trekking", "Horse riding", "Picnicking"],
    bestTimeToVisit: "April to October",
    slug: "Yusmarg",
  },
  {
    title: "Aharbal",
    description:
      "Known as the 'Niagara Falls of Kashmir,' Aharbal Waterfall is a stunning natural wonder surrounded by dense forests and a serene environment.",
    image: {
      src: dalImg, // Placeholder image
      alt: "Aharbal Waterfall",
    },
    distanceFromSrinagar: "75 km",
    famousFor: "Waterfall, trekking trails",
    activities: ["Photography", "Trekking", "Picnicking"],
    bestTimeToVisit: "April to October",
    slug: "Aharbal",
  },
  {
    title: "Manasbal Lake",
    description:
      "A haven for bird watchers, Manasbal Lake is one of the most serene lakes in Kashmir, known for its crystal-clear waters and lotus flowers.",
    image: {
      src: dalImg, // Placeholder image
      alt: "Manasbal Lake",
    },
    distanceFromSrinagar: "30 km",
    famousFor: "Bird watching, serenity",
    activities: ["Boating", "Picnicking", "Photography"],
    bestTimeToVisit: "April to October",
    slug: "Manasbal",
  },
  {
    title: "Bangus Valley",
    description:
      "An unspoiled valley, Bangus is known for its rolling meadows, lush greenery, and tranquil atmosphere, offering a perfect getaway for nature lovers.",
    image: {
      src: dalImg, // Placeholder image
      alt: "Bangus Valley",
    },
    distanceFromSrinagar: "128 km",
    famousFor: "Unexplored meadows, serene beauty",
    activities: ["Trekking", "Camping", "Photography"],
    bestTimeToVisit: "May to September",
    slug: "Bangus",
  },
];
